<template>
    <input
        class="form-control border-gray-300 h-11 focus:ring-0"
        v-model="modelForm[modelName]"
        :type="type"
        @input="inputFunction"
        :placeholder="placeholder"
        :disabled="isDisabled"
        :min="min"
        :style="isBgDanger ? 'border: red 2px solid' : ''"
    />
</template>

<script>
    export default {
        name: "InputTag",
        props: {
            modelForm: {
                type: Object,
                required: true,
            },
            modelName: {
                type: String,
                required: true,
            },

            // optional
            placeholder: {
                type: String,
                default: "",
            },
            type: {
                type: String,
                default: "text",
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
            inputFunction: {
                type: Function,
                default: function () {
                },
            },
            min: {
                type: String,
                default: null
            },
            isBgDanger: {
                type: Boolean,
                default: false
            }
        },
    }
</script>

<style scoped>
input:disabled {
    background-color: #fbfbfb !important;
}
</style>